//@flow
import React from 'react'
//import PropTypes from 'prop-types'
import ProgressIndicator from '../progress-indicators/progress-indicator'
import HeadingBeta from '../headings/heading-beta'
//import { GridRow, GridCol } from '../grid/index'
//import FlatButton from '../buttons/flat-button'
//import CtaButton from '../buttons/cta-button'
import LocationStep from '../../services/register-charity/Location'
import InformationStep from '../../services/register-charity/Information'
import LegalStep from '../../services/register-charity/Legal'
import ConfirmationStep from '../../services/register-charity/Confirmation'

export type RegisterCharityWizardProps = {
  onBack: () => void,
  onNext: () => void,
  cancelText: string,
  saveText: string,
  currentStep: number,
  pageTitle: string
}

const renderWizardContent = (props: RegisterCharityWizardProps) => {
  switch (props.currentStep) {
    case 2:
      return <InformationStep {...props} />
    case 3:
      return <LegalStep {...props} />
    case 4:
      return <ConfirmationStep {...props} />
    default:
      return <LocationStep {...props} />
  }
}

const RegisterCharityWizard = (props: RegisterCharityWizardProps) => (
  <div className='inner-wrapper'>
    {props.currentStep !== 4 && (
      <ProgressIndicator steps={3} active={props.currentStep} />
    )}
    {props.currentStep !== 4 && (
      <HeadingBeta className='top-space' center thin>
        {props.pageTitle}
      </HeadingBeta>
    )}
    {renderWizardContent(props)}
  </div>
)

RegisterCharityWizard.defaultProps = {
  currentStep: 1,
  pageTitle: 'Register My Charity'
}

export default RegisterCharityWizard



// WEBPACK FOOTER //
// ./src/ui/views/RegisterCharityWizard.js